import { DetailCard } from "../../Components/Card";

export const WeddingDetailPage = () => <DetailCard />;
